<div @toastAnimation [class]="toastClass()"
  (mouseenter)="onPointerEnter()" (mouseleave)="onPointerLeave()"
  (focusin)="onFocusIn()" (focusout)="onFocusOut($event)" (keydown)="onKeydown($event)">
  <svg class="toast-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
    stroke="currentColor" aria-hidden="true" focusable="false">
    <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="iconPath()" />
  </svg>
  <div class="toast-message" [class.toast-message--mono]="data().type === 'debug'">
    <span class="toast-visually-hidden">{{ typeLabel() }}: </span><span [innerHTML]="data().text"></span>
  </div>
  @if (data().action; as action) {
    <button type="button" class="toast-action" (click)="runAction()">{{ action.label }}</button>
  }
  <button type="button" (click)="close()" class="toast-close" aria-label="Dismiss notification">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
      aria-hidden="true" focusable="false">
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  </button>
</div>
